var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sectionHeading"},[_c('div',{staticClass:"line"}),(_vm.text != '')?_c('h4',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('div',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }